export const SET_INCOME_APPS = 'SET_INCOME_APPS';
export const SET_APPS = 'SET_APPS';
export const SET_STATUS = 'SET_STATUS';
export const SET_SEARCHING_VALUE = 'SET_SEARCHING_VALUE';
export const SET_PERIOD = 'SET_PERIOD';
export const SET_ACTIVE_PAGE = 'SET_ACTIVE_PAGE';
export const SET_PAGINATION_PAGES_COUNT = 'SET_PAGINATION_PAGES_COUNT';
export const SET_INCOME_APPS_WITH_PAGINATION = 'SET_INCOME_APPS_WITH_PAGINATION';
export const SET_APPS_WITH_PAGINATION = 'SET_APPS_WITH_PAGINATION';